<template>
  <div class="ah-product-search-controls">
    <search-bar
      :inputLabel="inputLabel"
      :inputPlaceholder="inputLabel"
      :buttonLabel="submitLabel"
      :onSubmit="handleSubmit"
    />
    <search-filters />
    <div v-if="showActiveFilters">
      <divider/>
      <active-filters
        :handleFilterRemove="handleFilterRemove"
        :handleClearFilters="handleClearFilters"
        :clearFiltersLabel="clearLabel"
      />
    </div>
    <filter-drawer />
  </div>
</template>

<script>
  import SearchBar from '../components/SearchBar.vue'
  import SearchFilters from '../components/SearchFilters/SearchFilters.vue'
  import Divider from '../components/shared/Divider.vue'
  import ActiveFilters from '../components/ActiveFilters/ActiveFilters.vue'

  import { store, mutations, getters } from '../data/store'
  import FilterDrawer from '../components/FilterDrawer.vue'

  export default {
    components: { SearchBar, SearchFilters, Divider, ActiveFilters, FilterDrawer },
    name: 'search-controls',
    data: function() {
      return {
        inputLabel: window.vueData.components['search-bar'].placeholder || 'Search products',
        submitLabel: window.vueData.components['search-bar'].submitButtonAriaLabel || 'Search',
        clearLabel: window.vueData.components['filters'].clearAllLabel || 'Clear all',
        queryParams: {
          search:  getters.activeQuery().length > 0 ? getters.activeQuery()[0].slug : null
        }
      }
    },
    methods: {
      handleFilterRemove: function(filter) {
        mutations.toggleFilter(filter)
      },
      handleClearFilters: function() {
        mutations.setFilters([])
      },
      handleSubmit: function(e) {
        e.preventDefault()
        const value = e.target[0].value || ''
        const filterQuery = !!this.queryParams.filters ? `&filters=${this.queryParams.filters}` : ''
        const targetUrl = `${window.location.origin}${window.location.pathname}?search=${value}${filterQuery}`
        window.location.href = targetUrl
      },
      handlePushState: function(params) {
        this.queryParams = {
          ...this.queryParams,
          ...params
        }
        const baseUrl = `${window.location.origin}${window.location.pathname}`
        let url = baseUrl
        if (!!this.queryParams.filters || !!this.queryParams.search)
          url += '?'
        if (!!this.queryParams.search) {
          url += `search=${this.queryParams.search}`
        }
        if (!!this.queryParams.filters) {
          if (!!this.queryParams.search) {
            url += '&'
          }
          url += `filters=${this.queryParams.filters}`
        }
        window.history.pushState(null, '', url)
      },
    },
    computed: {
      filters: function() {
        return store.filters
      },
      activeFilters: function() {
        return getters.activeFilters() || null
      },
      searchParams: function() {
        return getters.activeQuery() || null
      },
      showActiveFilters: function() {
        return (this.activeFilters.length > 0 || store.searchParams !== '')
      },
    },
    watch: {
      activeFilters: {
        handler: function(val, oldVal) {
          this.handlePushState({
            filters: val.map(e => e.slug).join(',') || null
          })
        },
        deep: true
      },
      searchParams: {
        handler: function(val, oldVal) {
          this.handlePushState({
            search: val.length > 0 ? val[0].slug : null
          })
        },
        deep: true,
      }
    },
  }
</script>

<style>

</style>
